import React, { useEffect, useMemo } from 'react';
import { isUndefined } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { AppBarCMS } from '../../../../basic';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { UnitsForm } from './UnitsForm.jsx';
import {
  useGetAttributeUnitDetailQuery,
  useSaveAttributeUnitMutation,
} from '../../../../../redux/services/attributeUnits';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import { Spinner } from '../../../../common';

export function UnitsEditPage() {
  const { t } = useTranslation();
  const { attributeUnitId } = useParams();
  const navigate = useNavigate();

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const isCreate = isUndefined(attributeUnitId);

  const { data: unitDetail, isLoading } = useGetAttributeUnitDetailQuery(
    attributeUnitId,
    {
      skip: isCreate,
    },
  );

  const [saveAttributeUnit, { isSuccess }] = useSaveAttributeUnitMutation();

  useEffect(() => {
    if (isSuccess) {
      showSaveSuccess();
      navigate(routes.cmsMeteoStationUnits);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  const initials = useMemo(() => {
    if (isCreate || isUndefined(unitDetail)) {
      return {};
    }

    return {
      unit: unitDetail.unit,
    };
  }, [isCreate, unitDetail]);

  return !isCreate && isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={isCreate ? t('Nová jednotka') : t('Úprava jednotky')}
        backUrl={routes.cmsMeteoStationUnits}
        backUrlTooltip={t('Správa jednotiek')}
      />

      <div style={{ margin: '10px' }}>
        <UnitsForm
          initials={initials}
          onSubmit={(values) => {
            saveAttributeUnit({
              id: attributeUnitId,
              values,
            });
          }}
        />
      </div>
    </>
  );
}

export default UnitsEditPage;
